import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfoStore: {}, // 用户信息
    navFeaturesData: null, // 导航栏专题菜单状态存储
    shoppingData: null, // 购物车
    shoppingDataCount: 5, // 购物车数量
    advancedFilter:[]
  },
  getters: {
    getUserInfo: state => {
      return state.userInfoStore
    }
  },
  mutations: {
    increment () {
    },
    setUserInfo (state, payload) { // 用户信息获取
      state.userInfoStore = payload
    },
    setAdvancedFilter(state,payload){
      state.advancedFilter = payload
    },
    setNavFeaturesData (state, payload) { // 导航栏专题菜单状态获取
      state.navFeaturesData = payload
    },
    setShoppingData (state, payload) { // 加入购物车
      state.shoppingData = payload
    },
    setNavShoppingCountStore (state, len) { // 购物车数量
      state.shoppingDataCount = 0
      if (state.shoppingData) state.shoppingDataCount = state.shoppingData.length
      if (len) state.shoppingDataCount = len
    }
  },
  actions: {
  },
  modules: {
  }
})
